import SkeletonLoader from "@/Layout/SkeletonLoader"

const FormLabel = (props) => {
    const { title, customClass, skeletonLoading, isRequired = false } = props
    return (
        <label className={`${customClass} sm:text-[0.95rem] text-sm font-medium text-neutral-700 mb-2 block tracking-tight`}>
            {skeletonLoading ? <SkeletonLoader width="200" height={28} rows={1} /> : <>{title}{isRequired && <span className="text-danger ms-1">*</span>}</>}
        </label>
    )
}

export default FormLabel
